import { useApolloClient } from '@apollo/client';
import { getPmPoolQuery } from '../DataQuery';
import { setData } from './common';

const useLoadPmPool = (contentRef, setContent) => {
    const { query } = useApolloClient();

    const loadPmPool = (oddsTypes, allRaces) => {
        return Promise.all([query({ 
            query : getPmPoolQuery(),
            variables: {
                "date": contentRef.current.date,
                "venueCode": contentRef.current.venue,
                "raceNo": allRaces ? 0 : contentRef.current.raceNo,
                "oddsTypes": oddsTypes
            },
            fetchPolicy: 'no-cache',
            notifyOnNetworkStatusChange: true 
        })])
        .then(([results]) => {
            if(results.errors){
                throw new Error(results.errors?.[0]?.message)
            }
            setPmPoolDataToContent(results);
        });
    }

    const loadBetSharePmPool = (params, callback) =>{
        return Promise.all([query({ 
            query : getPmPoolQuery(),
            variables: {
                "date": params.date,
                "venueCode": params.venueCode,
                "raceNo": params.raceNo,
                "oddsTypes": params.oddsTypes
            },
            fetchPolicy: 'no-cache',
            notifyOnNetworkStatusChange: true 
        })])
        .then(([results]) => {
            if(results.errors){
                throw new Error(results.errors?.[0]?.message)
            }
            if(callback){
                callback(results);
            }
            return results
        });
    }

    const setPmPoolDataToContent = (queryResult) => {
        if(!queryResult || !queryResult.data) return
        let oddsData = queryResult.data?.raceMeetings?.[0]?.pmPools || [];
        if(contentRef.current.page == "PWIN"){
            let pwin0 = oddsData.find(i => i.oddsType == "PWIN0" )
            let pwin1 = oddsData.find(i => i.oddsType == "PWIN1" )
            if(pwin0 && !pwin1){
                pwin1 = JSON.parse(JSON.stringify(pwin0));
                pwin1.id = pwin1.id.replace("PWIN0", "PWIN1")
                pwin1.oddsType = "PWIN1";
                oddsData.push(pwin1)
            }
        }
        oddsData.forEach(pmPool => {
            setData(contentRef, pmPool)
        });
        setContent({ ...contentRef.current });
    }

    return {
        loadPmPool,
        loadBetSharePmPool
    }
}

export default useLoadPmPool